import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import './motion.css';

export const PULL_THRESHOLD = 70;
const MAX_PULL = 110;

export function Rocket({ pull, phase }) {
  return (
    <div
      className={`svx-rocket ${phase === 'drag' ? 'is-dragging' : ''} ${phase === 'launch' ? 'is-launching' : ''}`}
      style={{ '--pull': pull, '--flame': Math.min(1, pull / PULL_THRESHOLD) }}
      aria-hidden="true"
      data-testid="pull-rocket"
    >
      <RocketLaunchIcon className="svx-rocket__body" />
      <span className="svx-rocket__flame" />
    </div>
  );
}

export default function RocketRefresh({ onRefresh, children, sx }) {
  const [pull, setPull] = useState(0);
  const [phase, setPhase] = useState('idle');
  const start = useRef(null);
  const box = useRef(null);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const pullable = (target) => {
    if (!box.current || !box.current.contains(target) || (window.scrollY || 0) > 0) return false;
    for (let el = target; el; el = el.parentElement) {
      if (el.scrollTop > 0) return false;
      if (el === box.current) return true;
    }
    return false;
  };

  const onTouchStart = (e) => {
    if (phase === 'launch' || !pullable(e.target)) { start.current = null; return; }
    start.current = e.touches[0].clientY;
  };
  const onTouchMove = (e) => {
    if (start.current === null) return;
    const dy = e.touches[0].clientY - start.current;
    if (dy <= 0) { setPull(0); return; }
    setPhase('drag');
    setPull(Math.min(MAX_PULL, dy * 0.6));
  };
  const onTouchEnd = () => {
    if (start.current === null) return;
    start.current = null;
    if (pull >= PULL_THRESHOLD) {
      setPhase('launch');
      onRefresh();
      timer.current = setTimeout(() => { setPhase('idle'); setPull(0); }, 700);
    } else {
      setPhase('idle');
      setPull(0);
    }
  };

  return (
    <Box
      ref={box}
      sx={{ position: 'relative', ...sx }}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchEnd}
    >
      {phase !== 'idle' && <Rocket pull={pull} phase={phase} />}
      <span className="svx-sr" role="status" aria-live="polite">{phase === 'launch' ? 'Refreshing' : ''}</span>
      {children}
    </Box>
  );
}
